import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './values.module.scss';

import florImg01 from '../../img/SweetPea_Purple_SideviewStem_BH_LR_RGB_0.jpg';
import florImg02 from '../../img/Telus_One_page-20.png';
import florImg03 from '../../img/flor3.png';
import florImg04 from '../../img/Telus_One_page-21.png';

let cx = classNames.bind(styles);

const Values = () => {
	const { t } = useTranslation();

	return (
		<section id='values' className={cx({ values: true })}>
			<div className='container flex flex-col w-full mx-auto'>
				<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-2xl lg:text-4xl px-4 lg:py-4'>
					Our values
				</h1>
				<div className='flex flex-col lg:flex-row w-full items-center lg:items-stretch'>
					<div className='flex flex-col w-10/12 lg:w-1/4 justify-between items-center lg:p-0 text-center shadow-2xl lg:mx-8 my-8 lg:my-0'>
						<p className='text-telus-purple text-2xl lg:text-xl font-HelveticaNeueLTStd-Roman lg:h-20 pt-8'>We believe in spirited teamwork.</p>
						<Img src={florImg01} className='w-8/12 pt-2 pb-0' />
					</div>
					<div className='flex flex-col w-10/12 lg:w-1/4 justify-between items-center lg:p-0 text-center shadow-2xl lg:mx-8 my-8 lg:my-0'>
						<p className='text-telus-purple text-2xl lg:text-xl font-HelveticaNeueLTStd-Roman lg:h-20 pt-8'>We embrace change and initiate opportunity.</p>
						<Img src={florImg02} className='w-8/12 pt-2 pb-0' />
					</div>
					<div className='flex flex-col w-10/12 lg:w-1/4 justify-between items-center lg:p-0 text-center shadow-2xl lg:mx-8 my-8 lg:my-0'>
						<p className='text-telus-purple text-2xl lg:text-xl font-HelveticaNeueLTStd-Roman lg:h-20 pt-8'>We have the courage to innovate</p>
						<Img src={florImg03} className='w-8/12 pt-2 pb-0' />
					</div>
					<div className='flex flex-col w-10/12 lg:w-1/4 justify-between items-center lg:p-0 text-center shadow-2xl lg:mx-8 my-8 lg:my-0'>
						<p className='text-telus-purple text-2xl lg:text-xl font-HelveticaNeueLTStd-Roman lg:h-20 pt-8'>We have a passion for growth</p>
						<Img src={florImg04} className='w-8/12 pt-2 pb-0' />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Values;
